import { useEffect } from 'react';

export const useKeydown = (keys: string | string[], callback: (event: KeyboardEvent) => void) => {
  useEffect(() => {
    const keyList = Array.isArray(keys) ? keys : [keys];

    const handleKeydown = (event: KeyboardEvent) => {
      if (keyList.includes(event.key)) {
        callback(event);
      }
    };

    window.addEventListener('keydown', handleKeydown);

    return () => {
      window.removeEventListener('keydown', handleKeydown);
    };
  }, [keys, callback]);
};
